<template>
  <div class="custom-form-prompt-dialog-content">
    <v-img :src="data.image_banner" cover aspect-ratio="1"></v-img>
    <c-btn
      block
      variant="primary-theme"
      @click="onAddAnswer"
      class="mt-2"
      data-test="custom-form-prompt-add-answer-btn"
    >
      {{ data.button_label }}
    </c-btn>
    <c-btn
      block
      variant="custom-link"
      @click="onSkip"
      data-test="custom-form-prompt-skip-btn"
    >
      <span data-lang="skip">{{ $t("skip") }}</span>
    </c-btn>
  </div>
</template>

<script>
export default {
  name: "CustomFormPromptDialogContent",
  props: {
    data: { type: Object, required: true },
    index: { type: Number, required: true },
    isBottomSheet: { type: Boolean, default: false }
  },
  emits: ["action", "close"],
  methods: {
    onAddAnswer() {
      let id = this.$cookies.get("modalShowId") || [];
      this.$cookies.set("modalShowId", [...id, this.data.id]);
      this.$emit("action", { action: "addAnswer", formId: this.data.id });
      this.$router.push("/form/" + this.data.id);
    },
    onSkip() {
      this.$emit("action", { action: "skip", nextIndex: this.index + 1 });
    }
  }
};
</script>

<style scoped></style>
